export default __webpack_public_path__ + "static/media/cards.5314b878.svg";